import './style.css.js';
import { useClassNames } from '@magnetic/hooks';
import { Status, StatusIcon } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import { TagFrame, compactIconSizeMap } from '../frame/index.js';

const BinaryTag = forwardRef(
  ({ active = true, children, className, size = "md", ...props }, ref) => {
    const classNames = useClassNames(
      "mds-rebuild-tag-binary",
      `mds-rebuild-tag-binary-${active ? "active" : "inactive"}`,
      "mds-rebuild-tag-compact",
      className
    );
    return /* @__PURE__ */ React.createElement(TagFrame, {
      ...props,
      className: classNames,
      prefix: active ? /* @__PURE__ */ React.createElement(Status, {
        height: compactIconSizeMap[size],
        status: "good",
        width: compactIconSizeMap[size]
      }) : /* @__PURE__ */ React.createElement(StatusIcon, {
        height: compactIconSizeMap[size],
        status: "inactive",
        width: compactIconSizeMap[size]
      }),
      ref,
      size
    }, children);
  }
);
BinaryTag.displayName = "Tag.Binary";

export { BinaryTag };
//# sourceMappingURL=index.js.map
